export enum RiskAssessment {
  RATING = 'rating',
  URGENCY = 'urgency',
  TRAFFIC_SAFETY_SCORE = 'trafficScore',
  OPERATIONAL_DOWNTIME = 'operationalDowntime',
  ENVIRONMENTAL_CONDITION = 'environmentalCondition',
}

export enum ComponentInfo {
  NAME = 'name',
  PK_DEFICIENCY_UUID = 'pkDeficiencyUUID',
  LOCATION_DESCRIPTION = 'locationDescription',
  COMMENT_ASSET_COMPONENT = 'commentAssetComponent',
  COMMENT_INSPECTOR_LEAD = 'commentInspectorLead',
  COMMENT_INSPECTOR_FIELD = 'commentInspectorField',
  ATTENTION_FLAG = 'attentionFlag',
  COMMENT_REMEDIAL_ACTION = 'commentRemedialAction',
  COMMENT_OBSERVATION = 'commentObservation',
  REMEDIAL_ACTION = 'remedialAction',
  REMEDIAL_ACTION_ID = 'remedialActionId',
  CAUSE_OF_FAILURE = 'causeOfFailure',
  FAILURE_CAUSE_CATEGORY = 'failureCauseCategory',
  COMPONENT_TYPE = 'componentType',
  ASSET_CATEGORY_COMPONENT_ID = 'assetCategoryComponentId',
  DATE_OBSERVED = 'dateObserved',
  COMPONENT_AREA_INFO = 'componentAreaInfo',
  REPAIR_FACTOR_ID = 'repairFactorId',
  IS_COMPLETED_DURING_INSPECTION = 'isCompletedDuringInspection',
  COMPONENT_FAILURE_ID = 'componentFailureId',
  IS_DELETE = 'isDelete',
  FK_COMPONENT = 'fkComponent',
  LOWER_ELEVATION = 'lowerElevation',
  UPPER_ELEVATION = 'upperElevation',
  IS_REINSPECTED_COMPONENT = 'isReInspectedComponent',
  COMPONENT_VERSION_ID = 'componentVersionId',
  OPERTION_DOWNTIME = 'inspectorOperationalDowntime',
  URGENCY = 'inspectorUrgency',
  TRAFFIC_SAFETY_SCORE = 'inspectorTrafficScore',
  CONDITION_RATING = 'inspectorConditionRating',
  COMPONENT_VERSION_INSPECTION_ID = 'componentVersionInspectionId',
  COMPONENT_VERSION_UUID = 'componentVersionUUID',
  IS_ADHOC = 'isAdhoc',
}

export enum Checklist {
  PK_ASSET_INSPECTION_COMPONENT_CHECKLIST = 'pk_AssetInspectionComponentChecklist',
  PK_UUID = 'pk_uuid',
  IS_DELETE = 'isDelete',
  ASSET_CATEGORY_COMPONENT = 'assetCategoryComponent',
  CHECKLIST_COMPONENT_NAME = 'checkListComponentName',
  FK_COMPONENT = 'fk_Component',
}

export enum ComponentInfoLabel {
  COMP_NAME = 'Component Name',
  COMP_LOCATION = ' Component Location',
  LOC_COMMENT = 'Location Comment',
  DATE_OBSERVED = 'Date Observed',
  COMP_TYPE = 'Component Type',
  COMP_TYPE_DETAILS = 'Component Type Details',
  REMEDIAL_ACTION = 'Remedial action',
  REMEDIAL_ACTION_DETAILS = 'Remedial action details',
  PRIMARY_CAUSE = 'Primary Cause of Failure',
  DEFICIENCY_DETAILS = 'Deficiency Details',
  DEFICIENCY_NAME = 'Deficiency Name',
  EQUIP_CIRCUIT = 'Equip/Circuit #',
  COMP_INFO = 'Component Infos',
  DEFICIENCY_INFO = 'Deficiency Info',
}

export enum FileType {
  AreaLayout = 11,
  Drawings,
  Layout,
  Pictures,
}

export enum SiteLayer {
  Surface = 'Surface',
  UnderGround = 'Underground',
  Shaft = 'Shaft',
}

export enum AreaType {
  MainArea = 'Main Area',
  SubArea = 'Sub Area',
  CubeArea = 'Cube Area',
  Elevation = 'Elevation',
  Asset = 'Asset',
}

export enum FileCategory {
  INSPECTION_FILE = 8,
  DEFICIENCY_FILE = 9,
  SIGN = 11,
  STAMP = 12,
}

export enum WorkPackageStatus {
  PLANNED = 1,
  ASSIGNED = 2,
  IN_PROGRESS = 3,
  COMPLETED = 4,
}

export enum TaskStatus {
  UPCOMING = 1,
  IN_PROGRESS = 2,
  PENDING = 3,
  COMPLETED = 4,
  ASSIGNED = 5,
  LI_PENDING_APPROVAL = 6,
  SC_PENDING_APPROVAL = 7,
  FI_SIGN_PENDING = 8,
  LI_SIGN_PENDING = 9,
}

export enum InspectionStatus {
  UPCOMING = 1,
  IN_PROGRESS = 2,
  PENDING = 3,
  COMPLETED = 4,
  ASSIGNED = 5,
  LI_PENDING_APPROVAL = 7,
  SC_PENDING_APPROVAL = 8,
  FI_SIGN_PENDING = 9,
  LI_SIGN_PENDING = 10,
}

export enum InspectorRole {
  LEAD = 6,
  FIELD = 7,
  SC = 3,
  DEC = 8,
}

export enum InspectorType {
  Nutrien = 'Nutrien',
  Service_Provider = 'ServiceProvider',
}

export enum FieldInspectorType {
  FI = 'FI',
  DEC = 'DEC',
}

export enum Discipline {
  'Electrical' = 1,
  'Mechanical',
  'Structural',
  'Shaft',
}

export enum Site {
  ALLAN = 1,
  CORY,
  LANIGAN,
  PATIENCE_LAKE,
  PENOBSQUIS,
  PICADILLY,
  ROCANVILLE,
  VANSCOY,
}

export enum Key {
  Enter = 'Enter',
}

export enum FieldInspectorTab {
  ONGOING = 0,
  APPROVAL = 1,
  UNASSIGN = 2,
}

export enum LeadInspectorTab {
  UNASSIGN = 0,
  ONGOING = 1,
  APPROVAL = 2,
}

export enum InspectionListTab {
  UN_ASSIGNED = 'Un Assigned',
  ON_GOING = 'On Going',
  APPROVAL = 'Approval',
}

export enum BulkButtons {
  SIGN_AND_STAMP = 'Sign & Stamp',
  RE_ASSIGN = 'Re-Assign',
  ASSIGN = 'Assign',
  ASSIGN_TO_ME = 'Assign To Me',
}

export enum LoginSteps {
  USERNAME = 'username',
  PASSWORD = 'password',
  SSO = 'sso',
  SMS_MFA = 'sms_mfa',
  FORGOT_PASSWORD = 'forgot_password',
}

export enum AreaTypes {
  SURFACE_MAIN = '11',
  SURFACE_SUB = '12',
  SURFACE_CUBE = '13',
  SURFACE_ASSET = '15',
  UNDERGROUND_MAIN = '21',
  UNDERGROUND_SUB = '22',
  UNDERGROUND_CUBE = '23',
  UNDERGROUND_ASSET = '25',
  SHAFT_ASSET = '35',
}

export enum EtapPropertiesLabel {
  ETAP_ID = 'ETAP ID',
  KV = 'kV',
  WORKING_DISTANCE = 'Working Distance LL (in)',
  TOTAL_ENERGY = 'Total Energy (cal/cm²)',
  AFB = 'AFB (ft-in)',
}

export enum ApiStatus {
  NOT_CALLED = 'NOT_CALLED',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum NotificationTab {
  UN_READ,
  READ,
}

export enum Filter {
  NONE = '',
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export enum BatchSize {
  ASSIGN = 5,
  RE_ASSIGN = 5,
  SIGN_AND_STAMP = 5,
}

export enum SiteLayerId {
  Surface = 1,
  UnderGround = 2,
  Shaft = 3,
}

export enum ComponentRemoval {
  REASON = 'componentRemoval',
  COMMENT = 'comment',
  PARENT_ID = 'parentComponentId',
  PARENT_ID_SEARCH = 'parentIdSearch',
  PARENT_NAME = 'parentComponentName',
}

export enum ComponentRemovalCategories {
  ACTIONED = 1,
  DUPLICATED = 2,
  NONE = 38,
}
